import { useAppDispatch } from '../../../app/hooks';
import { TeamMemberView } from '../../../services/TeamService';
import { addTeamMember, removeTeamMember } from '../state';
import { GraphUser } from '../../../utils/MsGraphApiCall';

/**
 * Custom hook for team member management operations
 */
export const useTeamMemberManagement = () => {
  const dispatch = useAppDispatch();

  const handleAddMember = (selectedPerson: GraphUser, role: string = 'MEMBER') => {
    if (!selectedPerson) {
      return;
    }

    // Parse first and last name from displayName
    const nameParts = selectedPerson.displayName.split(' ');
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '';

    const memberToAdd: Omit<TeamMemberView, 'joinedDate'> = {
      userId: selectedPerson.userPrincipalName || selectedPerson.mail,
      displayName: selectedPerson.displayName,
      firstName: firstName,
      lastName: lastName,
      email: selectedPerson.mail,
      role: role,
      isActive: true,
      fullName: selectedPerson.displayName
    };

    dispatch(addTeamMember(memberToAdd));
  };

  const handleRemoveMember = (memberId: string) => {
    dispatch(removeTeamMember(memberId));
  };

  return {
    handleAddMember,
    handleRemoveMember
  };
};

export default useTeamMemberManagement;